import { ICSSInJSStyle } from '@fluentui/react-northstar';
import { useMemo } from 'react';
import { useTeamsTheme } from '../../shared/teams-theme/useTeamsTheme';
import { ZIndex } from '../../shared/utils/styles-helper';

interface IFullPageLoadingContextProviderStyles {
  centerAbsolute: ICSSInJSStyle;
  flexDimmed: ICSSInJSStyle;
}

export const useFullPageLoadingContextProviderStyles = (): IFullPageLoadingContextProviderStyles => {
  const { theme } = useTeamsTheme();

  return useMemo(() => {
    const centerAbsolute: ICSSInJSStyle = {
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      minWidth: '100%',
      minHeight: '100%',
      flex: 1,
      zIndex: ZIndex.Loader
    };

    return {
      centerAbsolute,
      flexDimmed: {
        ...centerAbsolute,
        backgroundColor:
          theme.siteVariables.colorScheme.default.backgroundDisabled1,
        opacity: 0.75,
        zIndex: ZIndex.LoaderDim
      }
    };
  }, [theme.siteVariables.colorScheme.default.backgroundDisabled1]);
};
